import React from 'react';
import PropTypes from 'prop-types';
import { AvailableQuantityOptions } from './available_quantity_options';

export function ProductQuantity(props) {
    return (
        <div className="product-price-and-qty__select-container">
            <select
                id="pdpTyreSizeSelect"
                className="product-price-and-qty__select"
                defaultValue={props.quantity}
                onChange={props.onQuantityChange}
            >
                <AvailableQuantityOptions
                    availableQuantities={props.availableQuantities}
                />
            </select>
        </div>
    );
}

ProductQuantity.propTypes = {
    availableQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    quantity: PropTypes.number.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
};
